<template>
    <div class="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <!-- Benefits Grid -->
        <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            <!-- Cost -->
            <div class="text-center">
                <div class="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg class="w-8 h-8 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"></path>
                    </svg>
                </div>
                <h3 class="text-lg font-semibold text-gray-900 mb-1">8x Cheaper</h3>
                <p class="text-sm text-gray-600">vs pro photographer</p>
            </div>

            <!-- No Scheduling -->
            <div class="text-center">
                <div class="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                </div>
                <h3 class="text-lg font-semibold text-gray-900 mb-1">Less than 1 hour</h3>
                <p class="text-sm text-gray-600">No scheduling needed</p>
            </div>

            <!-- Quality -->
            <div class="text-center">
                <div class="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                </div>
                <h3 class="text-lg font-semibold text-gray-900 mb-1">Indistinguishable</h3>
                <p class="text-sm text-gray-600">From real photos</p>
            </div>

            <!-- Professional -->
            <div class="text-center">
                <div class="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg class="w-6 h-6 text-gray-600" fill="currentColor" stroke="none" viewBox="0 0 24 24">
                        <text x="12" y="16" text-anchor="middle" class="text-xs font-bold uppercase" fill="currentColor">PRO</text>
                    </svg>
                </div>
                <h3 class="text-lg font-semibold text-gray-900 mb-1">Professional</h3>
                <p class="text-sm text-gray-600">LinkedIn ready</p>
            </div>

            <!-- Styles -->
            <div class="text-center">
                <div class="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 10h16M4 14h16M4 18h16"></path>
                    </svg>
                </div>
                <h3 class="text-lg font-semibold text-gray-900 mb-1">50+ Styles</h3>
                <p class="text-sm text-gray-600">vs 1 at studios</p>
            </div>

            <!-- Quantity -->
            <div class="text-center">
                <div class="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                    </svg>
                </div>
                <h3 class="text-lg font-semibold text-gray-900 mb-1">100+ Headshots</h3>
                <p class="text-sm text-gray-600">vs 1-5 at studios</p>
            </div>

            <!-- Home -->
            <div class="text-center">
                <div class="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"></path>
                    </svg>
                </div>
                <h3 class="text-lg font-semibold text-gray-900 mb-1">From Home</h3>
                <p class="text-sm text-gray-600">No studio visits</p>
            </div>



            <!-- No Prep -->
            <div class="text-center">
                <div class="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <!-- Simple outlined t-shirt icon -->
                    <svg class="w-6 h-6 text-gray-600" viewBox="0 0 256 256" fill="none" stroke="currentColor" stroke-width="10" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M243.41357,64.772,193.98438,36.52686c-.06421-.03663-.13306-.05542-.19849-.08838a3.97629,3.97629,0,0,0-.39649-.17627c-.1206-.04492-.24145-.08033-.364-.1128-.12549-.03344-.251-.06323-.38086-.08447a3.92434,3.92434,0,0,0-.42285-.04248C192.14673,36.01807,192.07593,36,192,36H160a4.0002,4.0002,0,0,0-4,4,28,28,0,0,1-56,0,4.0002,4.0002,0,0,0-4-4H64c-.07324,0-.14185.01758-.21411.02148a3.93044,3.93044,0,0,0-.43335.044c-.12793.02075-.251.05029-.37451.083a3.82774,3.82774,0,0,0-.36817.11426,3.92288,3.92288,0,0,0-.39526.17578c-.06567.03271-.13452.05151-.199.08838L12.58594,64.77246a12.006,12.006,0,0,0-4.7793,15.78565l18.40479,36.8081A11.93373,11.93373,0,0,0,36.94434,124H60v84a12.01375,12.01375,0,0,0,12,12H184a12.01375,12.01375,0,0,0,12-12V124h23.05566a11.93415,11.93415,0,0,0,10.73291-6.6333l18.40528-36.80908A12.00661,12.00661,0,0,0,243.41357,64.772ZM36.94434,116a3.97784,3.97784,0,0,1-3.57764-2.21143L14.9624,76.98047a4.002,4.002,0,0,1,1.59278-5.26221L60,46.89282V116ZM188,208a4.00458,4.00458,0,0,1-4,4H72a4.00458,4.00458,0,0,1-4-4V44H92.2207a36.00247,36.00247,0,0,0,71.5586,0H188ZM241.03809,76.98,222.6333,113.78906A3.97826,3.97826,0,0,1,219.05566,116H196V46.89282l43.44434,24.825A4.0026,4.0026,0,0,1,241.03809,76.98Z"/>
                    </svg>
                </div>
                <h3 class="text-lg font-semibold text-gray-900 mb-1">No Special Clothes</h3>
                <p class="text-sm text-gray-600">No ironing needed</p>
            </div>
        </div>

        <!-- Warning -->
        <div class="border-t border-gray-200 pt-8 max-w-3xl mx-auto">
            <p class="text-sm text-gray-600 text-center">
                Unlike cheap or free AI services that just slap your face onto someone else's body, our advanced technology takes a bit longer to learn a 3D model of you, creating authentic, professional headshots that actually look like you.
            </p>
        </div>
    </div>
</template>

<script>
export default {
    // No data needed - simplified structure
};
</script>

<style scoped>
/* Minimal styling for subtle appearance */
</style>
